import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import PropTypes from 'prop-types';

/**
 * ExchangeRateCard - Displays the exchange rate information
 * Shows the conversion rate between USD and BRL
 */
const ExchangeRateCard = ({ exchangeRate }) => {
  exchangeRate = parseFloat(exchangeRate);
  return (
    <Card variant="outlined" sx={{ mb: 3, bgcolor: 'background.paper' }}>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
          <Box display="flex" alignItems="center" mb={{ xs: 1, sm: 0 }}>
            <CurrencyExchangeIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6">
              Exchange Rate (USD to BRL)
            </Typography>
          </Box>
          <Chip
            label={`USD 1.00 = BRL ${typeof exchangeRate === 'number' && !isNaN(exchangeRate) ? exchangeRate.toFixed(2) : '-'}`}
            color="primary"
            variant="outlined"
            sx={{ fontWeight: 'bold', fontSize: '1rem', px: 1 }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

ExchangeRateCard.propTypes = {
  exchangeRate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

export default ExchangeRateCard;